import React, { useState } from 'react'
// import { AiTwotoneShop, AiOutlineRight, AiFillCrown } from 'react-icons/ai'
// import { useDispatch } from 'react-redux'
// import { setProductsFilter } from '@reducers/contentReducer'
// import { useNavigate } from 'react-router-dom'
// import SearchData from '@data/SearchData'
import './FindTire.css'
// import BrandsData from '@data/BrandsData'
import FindTireBySize from './FindTireBySize'
import FindTireByBrand from './FindTireByBrand'
import FindTireByVehicle from './FindTireByVehicle'
import { useSelector } from 'react-redux'

export default function FindTire({
    setTireTypeOpen,
    setTireBrandOpen,
    extraClass
}) {

    // const navigate = useNavigate()
    // const dispatch = useDispatch()
    // const [formData, setFormData] = useState({
    //     width: 'TIRE WIDTH',
    //     profile: 'ASPECT RATIO',
    //     rim: 'RIM SIZE',
    //     type: 'ALL TIRES',
    //     // brand: 'ALL BRANDS'
    // })
    // const isMobile = useSelector((state) => state.content.isMobile)
    const [type, setType] = useState('vehicle')

    return (
        <div className={'tire-search-wrapper'} style={extraClass}>
            <div className='tire-search-tab'>
                <div className={`tire-search-title ${type === 'vehicle' && 'tire-search-title-active'}`} onClick={() => {
                    setType('vehicle')
                }}>Search by vehicle</div>
                <div className={`tire-search-title ${type === 'size' && 'tire-search-title-active'}`} onClick={() => {
                    setType('size')
                }}>Search by size</div>
                <div className={`tire-search-title ${type === 'brand' && 'tire-search-title-active'}`} onClick={() => {
                    setType('brand')
                }}>Quick Search</div>
            </div>
            {type === 'vehicle' &&
                <FindTireByVehicle setType={setType} />
            }
            {type === 'size' &&
                <FindTireBySize setType={setType} />
            }
            {type === 'brand' &&
                <FindTireByBrand
                    setTireTypeOpen={setTireTypeOpen}
                    setTireBrandOpen={setTireBrandOpen}
                    setType={setType}
                />
            }
        </div>
    )
}
